import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { apiKey: String }

  async connect() {
    await this.loadApi()

    const locations = [
      {
        lat: 37.431489,
        lng: -122.163719,
        label: "S",
        title: "Stanford",
        www: "https://www.stanford.edu/",
      },
      {
        lat: 37.394694,
        lng: -122.150333,
        label: "T",
        title: "Tesla",
        www: "https://www.tesla.com/",
      },
      {
        lat: 37.331681,
        lng: -122.0301,
        label: "A",
        title: "Apple",
        www: "https://www.apple.com/",
      },
      {
        lat: 37.484722,
        lng: -122.148333,
        label: "F",
        title: "Facebook",
        www: "https://www.facebook.com/",
      },
    ]

    this.map = new google.maps.Map(this.element, {
      center: { lat: 37.431489, lng: -122.163719 },
      zoom: 11,
    })

    locations.forEach((location) => {
      const infoWindow = new google.maps.InfoWindow({
        content: `<a href="${location.www}" target="_blank"><strong>${location.title}</strong></a>`,
        maxWidth: 200,
      })
      const marker = new google.maps.Marker({
        position: location,
        label: location.label,
        map: this.map,
        title: location.title,
      })

      marker.addListener("click", () => infoWindow.open(this.map, marker))
    })
  }

  loadApi() {
    if (window.google?.maps) return Promise.resolve()
    if (window.googleMapsPromise) return window.googleMapsPromise

    window.googleMapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script")
      script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(this.apiKeyValue)}`
      script.async = true
      script.addEventListener("load", resolve)
      script.addEventListener("error", reject)
      document.head.appendChild(script)
    })
    return window.googleMapsPromise
  }
}
